export enum ResultsCategory {
  GREEN_FEE = 'green-fee',
  PRODUCTS = 'all',
  INSTRUCTION = 'teaching',
  PASS_CARNET = 'pass',
  PRACTICE = 'practice',
}
